import {Service} from 'typedi';
import {StrategyBuilder} from '../../StrategyBuilder';
import {ExstLabelsService} from '../../ExstLabelsStrategyService';
import type {ExstLabelsStrategyData} from '../../types/exst-labels-data.type';
import type {LabelListElement} from '../../../result-page/result-cards/subcomponents/uiaas-search-label-list';
import type {
  DeveloperPortalDocumentUiModel
} from '../../../../models/ui/documents/exchange/developer-portal-document-ui.model';

@Service({id: 'exstLabelsStrategyService'})
export class ExstLabelsStrategyBuilder extends StrategyBuilder<ExstLabelsStrategyService> {
  build(details: ExstLabelsStrategyData): ExstLabelsStrategyService {
      return new ExstLabelsStrategyService(details as unknown as Record<'labels', Array<keyof DeveloperPortalDocumentUiModel>>);
  }
}


export class ExstLabelsStrategyService extends ExstLabelsService {
  details;

  constructor(details: Record<'labels', Array<keyof DeveloperPortalDocumentUiModel>> = { labels:[] }) {
      super();
      this.details = details;
  }

  getLabels(doc:DeveloperPortalDocumentUiModel) : LabelListElement[]{
      const { labels } = this.details.params;

      return labels.map((key:string)=>{

          const value = Array.isArray(doc[key as string])
            ? doc[key].filter((cat:string)=> !/Developer Resources/i.test(cat)).pop()
            : doc[key];

          return { value };
      })
        .filter(label=>!!label.value);
  }
}
